import React, { useEffect } from 'react';

import ReporteNuevosClientesList from './list/ReporteNuevosClientesList';
import ReporteNuevosClientesSearch from './components/ReporteNuevosClientesSearch';

const ReporteNuevosClientes = (props) => {
  useEffect(() => {
    window.setAppTitle('Nuevos Clientes');

    return () => window.setAppTitle('');
  }, []);

  const handleOnRowSelectionChange = ({ selectedRowKeys, selectedRows }) => {
    this.setState({
      selectedRowKeys,
      selectedRows,
    });
  };

  const handleOnRowClick = (data) => {
    const newData = {
      ...data,
      origen: 'reportes',
    };

    props.history.replace({
      pathname: `/admin/reportes/clientes/${data.id}/info`,
      state: {
        data: { ...newData },
      },
    });
  };

  return (
    <div>
      <ReporteNuevosClientesSearch />

      <ReporteNuevosClientesList
        onRowClick={handleOnRowClick}
        onRowSelectionChange={handleOnRowSelectionChange}
      />
    </div>
  );
};

export default ReporteNuevosClientes;
